export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';
export const REQUEST_COUNTRIES_PENDING = 'REQUEST_COUNTRIES_PENDING';
export const REQUEST_COUNTRIES_SUCCESS = 'REQUEST_COUNTRIES_SUCCESS';
export const REQUEST_COUNTRIES_FAILED = 'REQUEST_COUNTRIES_FAILED';
export const CHANGE_REGION_DROPDOWN = 'CHANGE_REGION_DROPDOWN';